var html = $('html');
var body = $('body');
var timeout;
var st = 0;
var lastSt = 0;
var titleOffset = 0;
var contentOffset = 0;
var progress = $('.sticky-progress');

$(function () {
    'use strict';
    subMenu();
    whiteLogo();
    whiteIcon();
    featured();
    pagination();
    video();
    gallery();
    table();
    toc();
    modal();
    search();
    burger();
    theme();
});

$(window).on('scroll', function () {
    'use strict';
    if (body.hasClass('post-template')) {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(sticky);
    }
});

$(window).on('load', function () {
    'use strict';
    if (body.hasClass('post-template')) {
        titleOffset = $('.single-title').offset().top;

        var content = $('.single-content');
        var contentHeight = content.height();
        contentOffset =
            content.offset().top + contentHeight - $(window).height() / 2;
    }
});

function sticky() {
    'use strict';
    st = jQuery(window).scrollTop();

    if (titleOffset > 0 && contentOffset > 0) {
        if (st > lastSt) {
            if (st > titleOffset) {
                body.addClass('sticky-visible');
            }
        } else {
            if (st <= titleOffset) {
                body.removeClass('sticky-visible');
            }
        }
    }

    progress.css(
        'transform',
        'translate3d(' +
            (-100 + Math.min((st * 100) / contentOffset, 100)) +
            '%,0,0)'
    );

    lastSt = st;
}

function subMenu() {
    'use strict';
    var mainNav = $('.main-nav');
    var separator = mainNav.find('.menu-item[href*="..."]');

    if (separator.length) {
        separator.nextAll('.menu-item').wrapAll('<div class="sub-menu" />');
        separator.replaceWith(
            '<button class="button-icon menu-item-button menu-item-more" aria-label="More"><svg class="icon"><use xlink:href="#dots-horizontal"></use></svg></button>'
        );

        var toggle = mainNav.find('.menu-item-more');
        var subMenu = $('.sub-menu');
        toggle.append(subMenu);

        toggle.on('click', function () {
            if (!subMenu.is(':visible')) {
                subMenu.show().addClass('animate__animated animate__bounceIn');
            } else {
                subMenu.addClass('animate__animated animate__zoomOut');
            }
        });

        subMenu.on('animationend', function (e) {
            subMenu.removeClass(
                'animate__animated animate__bounceIn animate__zoomOut'
            );
            if (e.originalEvent.animationName == 'zoomOut') {
                subMenu.hide();
            }
        });
    }
}

function whiteLogo() {
    'use strict';
    if (typeof gh_white_logo != 'undefined') {
        var whiteImage =
            '<img class="logo-image white" src="' + gh_white_logo + '">';
        $('.logo').prepend(whiteImage);
    }
}

function whiteIcon() {
    'use strict';
    if (typeof gh_white_icon != 'undefined') {
        var whiteImage =
            '<img class="cover-icon-image white" src="' + gh_white_icon + '">';
        $('.cover-icon').prepend(whiteImage);
    }
}

function featured() {
    'use strict';
    $('.featured-feed').owlCarousel({
        dots: false,
        margin: 30,
        nav: true,
        navText: [
            '<svg class="icon"><use xlink:href="#chevron-left"></use></svg>',
            '<svg class="icon"><use xlink:href="#chevron-right"></use></svg>',
        ],
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
        },
    });
}

function pagination() {
    'use strict';
    var wrapper = $('.post-feed');

    if (body.hasClass('paged-next')) {
        wrapper.infiniteScroll({
            append: '.feed',
            button: '.infinite-scroll-button',
            debug: false,
            hideNav: '.pagination',
            history: false,
            path: '.pagination .older-posts',
            scrollThreshold: false,
            status: '.infinite-scroll-status',
        });
    }

    wrapper.on('append.infiniteScroll', function (
        event,
        response,
        path,
        items
    ) {
        $(items[0]).addClass('feed-paged');
    });
}

function video() {
    'use strict';
    $('.single-content').fitVids();
}

function gallery() {
    'use strict';
    pswp(
        '.kg-gallery-container',
        '.kg-gallery-image',
        '.kg-gallery-image',
        false,
        true
    );
}

function table() {
    'use strict';
    if (body.hasClass('post-template') || body.hasClass('page-template')) {
        var tables = $('.single-content').find('.table');
        tables.each(function (_, table) {
            var labels = [];

            $(table)
                .find('thead th')
                .each(function (_, label) {
                    labels.push($(label).text());
                });

            $(table)
                .find('tr')
                .each(function (_, row) {
                    $(row)
                        .find('td')
                        .each(function (index, column) {
                            $(column).attr('data-label', labels[index]);
                        });
                });
        });
    }
}

function toc() {
    'use strict';
    if (body.hasClass('post-template')) {
        var output = '';
        var toggle = $('.sticky-toc-button');

        $('.single-content')
            .find('> h2, > h3')
            .each(function (index, value) {
                var linkClass =
                    $(this).prop('tagName') == 'H3'
                        ? 'sticky-toc-link sticky-toc-link-indented'
                        : 'sticky-toc-link';
                output +=
                    '<a class="' +
                    linkClass +
                    '" href="#' +
                    $(value).attr('id') +
                    '">' +
                    $(value).text() +
                    '</a>';
            });

        if (output == '') {
            toggle.remove();
        }

        $('.sticky-toc').html(output);

        toggle.on('click', function () {
            body.toggleClass('toc-opened');
        });

        $('.sticky-toc-link').on('click', function (e) {
            e.preventDefault();
            var link = $(this).attr('href');

            $('html, body').animate(
                {
                    scrollTop: $('[id="' + link.substring(1) + '"]').offset().top - 82,
                },
                500
            );
        });
    }
}

function modal() {
    'use strict';
    var modalOverlay = $('.modal-overlay');
    var modal = $('.modal');
    var modalInput = $('.modal-input');

    $('.js-modal').on('click', function (e) {
        e.preventDefault();
        modalOverlay.show().outerWidth();
        body.addClass('modal-opened');
        modalInput.focus();
    });

    $('.modal-close, .modal-overlay').on('click', function () {
        body.removeClass('modal-opened');
    });

    modal.on('click', function (e) {
        e.stopPropagation();
    });

    $(document).keyup(function (e) {
        if (e.keyCode === 27 && body.hasClass('modal-opened')) {
            body.removeClass('modal-opened');
        }
    });

    modalOverlay.on('transitionend', function (e) {
        if (!body.hasClass('modal-opened')) {
            modalOverlay.hide();
        }
    });

    modal.on('transitionend', function (e) {
        e.stopPropagation();
    });
}

function search() {
    'use strict';
    if (
        typeof gh_search_key == 'undefined' ||
        gh_search_key == ''
    )
        return;

    var searchInput = $('.search-input');
    var searchButton = $('.search-button');
    var searchResult = $('.search-result');
    var popular = $('.popular-wrapper');
    var includeContent = typeof gh_search_content == 'undefined' || gh_search_content == true ? true : false;

    var url =
        siteUrl +
        '/ghost/api/v3/content/posts/?key=' +
        gh_search_key +
        '&limit=all&fields=id,title,url,updated_at,visibility&order=updated_at%20desc';
    url += includeContent ? '&formats=plaintext' : '';
    var indexDump = JSON.parse(localStorage.getItem('dawn_search_index'));
    var index;

    elasticlunr.clearStopWords();

    localStorage.removeItem('dawn_index');
    localStorage.removeItem('dawn_last');

    function update(data) {
        data.posts.forEach(function (post) {
            index.addDoc(post);
        });

        try {
            localStorage.setItem('dawn_search_index', JSON.stringify(index));
            localStorage.setItem('dawn_search_last', data.posts[0].updated_at);
        } catch (e) {
            console.error('Your browser local storage is full. Update your search settings following the instruction at https://github.com/TryGhost/Dawn#disable-content-search');
        }
    }

    if (
        !indexDump
    ) {
        $.get(url, function (data) {
            if (data.posts.length > 0) {
                index = elasticlunr(function () {
                    this.addField('title');
                    if (includeContent) {
                        this.addField('plaintext');
                    }
                    this.setRef('id');
                });

                update(data);
            }
        });
    } else {
        index = elasticlunr.Index.load(indexDump);

        $.get(
            url +
                "&filter=updated_at:>'" +
                localStorage
                    .getItem('dawn_search_last')
                    .replace(/\..*/, '')
                    .replace(/T/, ' ') +
                "'",
            function (data) {
                if (data.posts.length > 0) {
                    update(data);
                }
            }
        );
    }

    searchInput.on('keyup', function (e) {
        var result = index.search(e.target.value, { expand: true });
        var output = '';

        result.forEach(function (post) {
            output +=
                '<div class="search-result-row">' +
                '<a class="search-result-row-link" href="' +
                post.doc.url +
                '">' +
                post.doc.title +
                '</a>' +
                '</div>';
        });

        searchResult.html(output);

        if (e.target.value.length > 0) {
            searchButton.addClass('search-button-clear');
        } else {
            searchButton.removeClass('search-button-clear');
        }

        if (result.length > 0) {
            popular.hide();
        } else {
            popular.show();
        }
    });

    $('.search-form').on('submit', function (e) {
        e.preventDefault();
    });

    searchButton.on('click', function () {
        if ($(this).hasClass('search-button-clear')) {
            searchInput.val('').focus().keyup();
        }
    });
}

function burger() {
    'use strict';
    $('.burger').on('click', function () {
        body.toggleClass('menu-opened');
    });
}

function theme() {
    'use strict';
    var toggle = $('.js-theme');
    var toggleText = toggle.find('.theme-text');

    function system() {
        html.removeClass(['theme-dark', 'theme-light']);
        localStorage.removeItem('dawn_theme');
        toggleText.text(toggle.attr('data-system'));
    }

    function dark() {
        html.removeClass('theme-light').addClass('theme-dark');
        localStorage.setItem('dawn_theme', 'dark');
        toggleText.text(toggle.attr('data-dark'));
    }

    function light() {
        html.removeClass('theme-dark').addClass('theme-light');
        localStorage.setItem('dawn_theme', 'light');
        toggleText.text(toggle.attr('data-light'));
    }

    switch (localStorage.getItem('dawn_theme')) {
        case 'dark':
            dark();
            break;
        case 'light':
            light();
            break;
        default:
            system();
            break;
    }

    toggle.on('click', function (e) {
        e.preventDefault();

        if (!html.hasClass('theme-dark') && !html.hasClass('theme-light')) {
            dark();
        } else if (html.hasClass('theme-dark')) {
            light();
        } else {
            system();
        }
    });
}

function pswp(container, element, trigger, caption, isGallery) {
    var parseThumbnailElements = function (el) {
        var items = [],
            gridEl,
            linkEl,
            item;

        $(el)
            .find(element)
            .each(function (i, v) {
                gridEl = $(v);
                linkEl = gridEl.find(trigger);

                item = {
                    src: isGallery
                        ? gridEl.find('img').attr('src')
                        : linkEl.attr('href'),
                    w: 0,
                    h: 0,
                };

                if (caption && gridEl.find(caption).length) {
                    item.title = gridEl.find(caption).html();
                }

                items.push(item);
            });

        return items;
    };

    var openPhotoSwipe = function (index, galleryElement) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        options = {
            closeOnScroll: false,
            history: false,
            index: index,
            shareEl: false,
            showAnimationDuration: 0,
            showHideOpacity: true,
        };

        gallery = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            options
        );
        gallery.listen('gettingData', function (index, item) {
            if (item.w < 1 || item.h < 1) {
                // unknown size
                var img = new Image();
                img.onload = function () {
                    // will get size after load
                    item.w = this.width; // set image width
                    item.h = this.height; // set image height
                    gallery.updateSize(true); // reinit Items
                };
                img.src = item.src; // let's download image
            }
        });
        gallery.init();
    };

    var onThumbnailsClick = function (e) {
        e.preventDefault();

        var index = $(e.target)
            .closest(container)
            .find(element)
            .index($(e.target).closest(element));
        var clickedGallery = $(e.target).closest(container);

        openPhotoSwipe(index, clickedGallery[0]);

        return false;
    };

    $(container).on('click', trigger, function (e) {
        onThumbnailsClick(e);
    });
}

// Open external links in new tab

[...document.querySelectorAll("a")].forEach(link => {
    link.setAttribute("target", "_blank");
});

if(document.querySelector('.single.post')){
    
    if(!document.querySelector('.no-article-a') && document.querySelector('.cta-product')){
        document.querySelector('.cta-product').classList.add('article-a')
    }
}

//Hide Floating CTA on certain pages

if(document.querySelector('.no-bottom-float')){
    document.querySelector('.cta-product-floating').style.display = "none"
}

//Table search


if(document.getElementById('jobQuery')){

    let toScroll = 0;

    document.querySelectorAll('.see-more-btn').forEach(e=>{
        e.addEventListener('click', (e)=>{
            //document.getElementById(e.target.dataset.item).style.display = "block"

            toScroll = window.scrollY

            document.querySelector('.see-more-p-content').innerHTML = document.getElementById(e.target.dataset.item).innerHTML
            document.querySelector('.see-more-p').classList.add("open")
            document.querySelector('body').classList.add("no-scroll")

        })
    })

    document.querySelector('.cross-p').addEventListener('click',()=>{
        document.querySelector('.see-more-p').classList.remove('open')
        document.querySelector('body').classList.remove("no-scroll")
        window.scrollTo(0, toScroll)
    })

    let amount = 50
    let items = 50
    function LoadItems(){

        let docs = document.querySelectorAll('tr')
        docs.forEach((e,i)=>{
            
            if(i>items){
                e.style.display = "none";
            } else {
                e.style.display = "table-row";
            }

            if(items > docs.length){
                
                document.querySelector('.load-more').style.display = 'none'
                document.querySelector('.load-more').insertAdjacentHTML('beforeend', "<p>End of the list.</p>")
            }
        })
    }
    LoadItems()

    document.querySelector('.load-more').addEventListener('click', ()=>{
        items = items + amount
        LoadItems()
    })

    function performSearch() {

        var filter = searchBox.value.toUpperCase();
    
        for (var rowI = 0; rowI < trs.length; rowI++) {
            var tds = trs[rowI].getElementsByTagName("td");
            trs[rowI].style.display = "none";
            
            for (var cellI = 0; cellI < tds.length; cellI++) {
            if (tds[cellI].innerHTML.toUpperCase().indexOf(filter) > -1) {
                trs[rowI].style.display = "";
                continue;
            }
            }
        }

        if(searchBox.value){
            document.querySelector('.load-more').style.display = 'none'
        } else {
            document.querySelector('.load-more').style.display = ''
            LoadItems()
        }
    
    }

    const searchBox = document.getElementById('jobQuery');
    const tbl = document.getElementById("jobTable");
    const trs = tbl.tBodies[0].getElementsByTagName("tr");

    // add event listener to search box
    searchBox.addEventListener('keyup', performSearch);

    //Table Sorting
    const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;

    const comparer = (idx, asc) => (a, b) => ((v1, v2) => 
        v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)
        )(getCellValue(asc ? a : b, idx), getCellValue(asc ? b : a, idx));

    let ascSort = false
    // do the work...
    document.querySelectorAll('th').forEach(th => th.addEventListener('click', (() => {
        const table = th.closest('table');

        table.querySelectorAll('tr').forEach(e=>{
            e.style.display = '';
        })

        table.querySelectorAll('th').forEach(e=>{
            e.classList.remove('sortAsc')
            e.classList.remove('sortDesc')
        })

        ascSort ? th.classList.add('sortAsc') : th.classList.add('sortDesc')

        Array.from(table.querySelectorAll('tbody tr:nth-child(n+1)'))
            .sort(comparer(Array.from(th.parentNode.children).indexOf(th), this.asc = !this.asc))
            .forEach(tr => table.querySelector('tbody').appendChild(tr) );
        
        ascSort = !ascSort

        LoadItems()
        
    })));

    /* const queryString = window.location.href.split('thanks=')[1]
    if(queryString){
        document.querySelector('.thanks-alert').style.display = 'block'
    } */

    const submitForm = () => {
        
        const user_name = document.querySelector('#name').value
        const company_name = document.querySelector('#company-name').value
        const company_jobs_page = document.querySelector('#company-jobs-page').value
        const further_comments = document.querySelector('#further-comments').value
        
    
        if(user_name.length > 0){

            if(company_name.length <= 0){
                document.querySelector('.message').innerHTML = "<div class='alert error-alert'>Please enter a company name.</div>"
                return
            }

            if(company_jobs_page.length <= 0){
                document.querySelector('.message').innerHTML = "<div class='alert error-alert'>Company jobs page is required.</div>"
                return
            }

            if(further_comments.length <= 0){
                document.querySelector('.message').innerHTML = "<div class='alert error-alert'>Further comments is required.</div>"
                return
            }
            
    
            document.querySelector('.form-holder').innerHTML = '<div class="loading"><img src="/assets/landing/images/loading.svg" height="30"> <br> Submitting...</div>'
    
            fetch("https://submit-form.com/y1Wa2EuI", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              name: user_name,
              company_name: company_name,
              company_jobs_page: company_jobs_page,
              further_comments: further_comments
            }),
          })
            .then(function (response) {
              console.log(response);
              document.querySelector('.form-holder').innerHTML = "<div class='alert thanks-alert'>Thank you for submitting the form. Your Response has been recorded.</div>"
            })
            .catch(function (error) {
              console.error(error);
            });
    
        } else {
            document.querySelector('.message').innerHTML = "<div class='alert error-alert'>Please enter your name.</div>"
        }
        
    }
    
    document.querySelector('.submit-button').addEventListener('click', submitForm);
    

}

const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

/*

    | Newsletter CTA

*/

const submitNewsletterForm = (place) => {
        
    const user_name = document.querySelector(`.${place} #name`).value
    const email = document.querySelector(`.${place} #email`).value

    if(user_name.length <= 0){
        document.querySelector(`.${place} .name-message`).innerHTML = "<div class='error error-alert'>Please enter your name.</div>"
        return
    } else {
        document.querySelector(`.${place} .name-message`).innerHTML = ""
    }

    if(email.length <= 0){
        document.querySelector(`.${place} .email-message`).innerHTML = "<div class='error error-alert'>Please enter your email.</div>"
        return
    } else {
        document.querySelector(`.${place} .email-message`).innerHTML = ""
    }

    if(!validateEmail(email)){
        document.querySelector(`.${place} .email-message`).innerHTML = "<div class='error error-alert'>Please enter a valid email address.</div>"
        return
    } else {
        document.querySelector(`.${place} .email-message`).innerHTML = ""
    }

    if(user_name && email){
        
        document.querySelector(`.${place} .form-holder`).innerHTML = '<div class="loading"><img src="/assets/landing/images/loading.svg" height="30"> <br> Submitting...</div>'

        fetch("https://submit-form.com/Lbq4vIwG", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: user_name,
          email: email
        }),
      })
        .then(function (response) {
          console.log(response);
          document.querySelector(`.${place} .form-holder`).innerHTML = "<div class='success'>Thank you for submitting the form. Your Response has been recorded.</div>"
          Cookies.set('newsletter-cta', 'closed', { expires: 365 })
        })
        .catch(function (error) {
          console.error(error);
        });

    } else {
        document.querySelector(`.${place} .name-message`).innerHTML = "<div class='alert error-alert'>Please enter your name.</div>"
    }
    

    
}

if(document.querySelector('.footer-newsletter')){
    document.querySelector('.footer-newsletter .join-btn').addEventListener('click', ()=>submitNewsletterForm('footer-newsletter'));
}

if(document.querySelector('.newsletter-cta')){

    if(!Cookies.get('newsletter-cta') || Cookies.get('newsletter-cta') != 'closed'){
        setTimeout(()=>{
            document.querySelector('.newsletter-cta').classList.add('open')
            document.querySelector('body').style.overflow = "hidden";
            document.querySelector('body').style.position = "fixed";
            document.querySelector('body').style.width = "100%";
        }, 3000)
    }

    document.querySelector('.newsletter-cta .cross').addEventListener('click', ()=>{
        document.querySelector('.newsletter-cta').classList.remove('open')
        document.querySelector('body').style.overflow = "inherit";
        document.querySelector('body').style.position = "inherit";
        document.querySelector('body').style.width = "inherit";
        
        if(Cookies.get('newsletter-cta') != 'closed'){
            Cookies.set('newsletter-cta', 'closed', { expires: 5 })
        }

    })

    document.querySelector('.newsletter-cta .join-btn').addEventListener('click', ()=>submitNewsletterForm('newsletter-cta'));
}

document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelector('.on-newsletter-page')){
        document.querySelector('.footer-nl').style.display = "none";
    }
});